import React from 'react';
import { motion } from 'framer-motion';
import { useApp } from '../../context/AppContext';

const StarNode = ({ presetId, size = 'md', delay = 0 }) => {
  const { presets } = useApp();
  const preset = presets.find(p => p.id === presetId) || { color: 'bg-slate-400', glow: 'shadow-slate-500/50' };
  
  const sizeClasses = {
    sm: 'w-2 h-2',
    md: 'w-4 h-4',
    lg: 'w-8 h-8',
    xl: 'w-16 h-16'
  };

  return (
    <motion.div
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay, duration: 0.5, type: 'spring' }}
      className="relative group"
    >
      {/* Glow Effect */}
      <div className={`absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ${sizeClasses[size]} rounded-full ${preset.color} blur-md opacity-50 group-hover:opacity-100 transition-opacity duration-300`} />
      
      {/* Star Core */}
      <div className={`relative ${sizeClasses[size]} rounded-full ${preset.color} shadow-lg ${preset.glow}`} />
    </motion.div>
  );
};

export default StarNode;